// startup
// Load entry module
__webpack_require__("./components/02-molecules/accordion-item/accordion-item.js");
// This entry module used 'exports' so it can't be inlined
